<template>
  <section :style="landingBanner">
    <div class="o-container o-container--responsive c-jumbotron--xlarge c-jumbotron--bukaemas-top u-bg--no-repeat">
      <bl-flex-container-mv direction="column" :gutter="32">
        <bl-flex-item-av :col="10">
          <bl-text-av tag="h1" variation="display-60" color="inverse">
            {{ $options.text.title }}
          </bl-text-av>
        </bl-flex-item-av>
        <bl-flex-item-av :col="8">
          <bl-text-av variation="body-16" color="inverse" style="font-size: 20px">
            {{ $options.text.subtitle }}
          </bl-text-av>
        </bl-flex-item-av>
        <bl-flex-item-av>
          <bl-button-av class="u-mrgn-right--2" size="large" color="green" @click="$emit('click')">
            {{ $options.text.tryNow }}
          </bl-button-av>

          <bl-button-av variation="outline" size="large" :is-ghost="true" @click="onLearnMoreClick">
            {{ $options.text.learnMore }}
          </bl-button-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>
<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { Header as text } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-dweb-2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexItemAv';
import BlButtonAv from '@bukalapak/bazaar-dweb/dist/components/BlButtonAv';

export default {
  name: 'Header',

  text,

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlButtonAv,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    landingBanner() {
      return {
        'padding-top': '80px',
        'background-repeat': 'no-repeat',
        'background-position': 'bottom center',
        'background-image': `url(${assetURL('hero_banner.png', this.isSSR)})`,
        height: '632px',
      };
    },
  },

  methods: {
    onLearnMoreClick() {
      const $more = document.getElementById('bukaemas_more');

      if ($more && window && window.scrollTo) {
        const offset = 140;
        const top = $more.offsetTop - offset;

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>
